import { RavenInputField } from '@ravenpay/raven-bank-ui';
import React, { useState } from 'react';
import AuthThreeLayoutWrap from '../../../layout/auth/AuthThreeLayoutWrap';
import ConfirmationPinModal from './modal/ConfirmationPinModal';
import './TeamInviteIndex.css';
import RootState, { InvitedMemberDetails } from '../../../redux/types';
import { getSupportInviteData } from '../../../redux/settings';
import { useDispatch, useSelector } from 'react-redux';
import { logger } from '../../../services/logger';
import { addTeamMember } from '../../../redux/auth';
import { useNavigate, useParams } from 'react-router-dom';

const TeamInviteIndex = () => {
	const atlasAuthLogo = (
		<svg
			className="img"
			width="130"
			height="48"
			viewBox="0 0 130 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="48" height="48" rx="8" fill="#B9DEFE" />
			<path
				d="M15.7985 12.6504C16.3907 13.5506 17.0655 14.3765 17.7391 15.2137C19.2237 17.0636 20.6942 18.9359 22.2905 20.698C22.7768 21.2348 23.3282 21.6928 24.0705 21.8626C27.0489 22.5378 29.577 20.4505 29.9225 17.6306C30.2553 14.9177 28.3577 12.0428 25.3491 12.0304C22.2187 12.0191 19.0875 12.009 15.9556 12C15.56 12 15.56 12.2149 15.6834 12.4501C15.7181 12.5188 15.7565 12.5856 15.7985 12.6504ZM36.9148 35.6299C36.6902 35.4262 36.4657 35.2225 36.2388 35.0222C34.9043 33.8295 20.9118 22.9147 14.6607 12.7618C14.6234 12.6971 14.5896 12.6307 14.5595 12.5626C14.5507 12.5383 14.5352 12.5167 14.5147 12.5003C14.4942 12.4838 14.4695 12.4731 14.4431 12.4692C14.3268 12.4523 14.2884 12.5446 14.2419 12.6166C14.0569 12.8968 13.9801 13.2186 13.8928 13.5326C13.3553 15.5085 13.1227 17.5272 13.0331 19.5593C12.9751 20.7854 12.9934 22.0137 13.0877 23.2377C13.2192 24.8434 13.4868 26.4221 14.0406 27.9456C14.563 29.3837 15.3204 30.6845 16.5466 31.6792C17.304 32.2815 18.1984 32.7015 19.1562 32.9046C19.3586 32.9507 19.3889 32.9147 19.319 32.7177C19.3074 32.6829 19.2935 32.6491 19.2807 32.6154C18.6307 30.9905 17.98 29.3661 17.3284 27.742C17.1726 27.3522 17.0152 26.9631 16.8581 26.5736C16.8256 26.4928 16.9005 26.4384 16.941 26.5155C17.5414 27.5372 18.1359 28.5634 18.742 29.5817C19.3842 30.6631 20.0974 31.6915 21.084 32.5141C21.952 33.2367 22.9717 33.7688 24.0728 34.0736C24.8569 34.3037 25.6651 34.4482 26.4823 34.5046C26.5474 34.5046 26.6254 34.5485 26.6719 34.4878C26.7185 34.427 26.6533 34.3662 26.6196 34.3133C26.2705 33.7744 25.9134 33.2342 25.5562 32.6975L22.7279 28.4464C21.905 27.2131 21.0863 25.9791 20.2719 24.7444L19.3203 23.3046C19.3122 23.2922 19.3164 23.2755 19.3295 23.2685C19.3397 23.263 19.3525 23.2652 19.3603 23.2738C19.3852 23.301 19.4104 23.3272 19.4331 23.3558C20.2475 24.3381 21.0026 25.3554 21.7762 26.3636C22.7594 27.6463 23.7459 28.9246 24.8209 30.1387C25.4026 30.7948 25.9972 31.4395 26.637 32.0415C27.5157 32.8894 28.4821 33.6476 29.5212 34.3044C30.2034 34.7282 30.9266 35.0869 31.6805 35.3755C32.5335 35.7023 33.4324 35.9037 34.3471 35.9731C35.1848 36.0371 36.0276 35.9868 36.8508 35.8234C36.9078 35.8122 36.9811 35.8155 36.9974 35.7446C37.0136 35.6738 36.9508 35.658 36.9148 35.6299Z"
				fill="#014345"
			/>
			<path
				d="M62.3 0V48H63.7V0H62.3Z"
				fill="#A0D2FE"
				mask="url(#path-1-outside-1_6716_379101)"
			/>
			<path
				d="M89.04 30L88.1 27.28H82.74L81.8 30H78.12L83.4 16H87.44L92.72 30H89.04ZM83.76 24.36H87.08L85.42 19.58L83.76 24.36ZM94.5731 26.58V22.72H92.8131V19.76H94.5731V16.76H97.9331V19.76H100.453V22.72H97.9331V26C97.9331 26.86 98.2531 27.14 99.2131 27.14C99.6531 27.14 100.073 27.1 100.493 27V29.86C99.8531 30.04 99.1331 30.14 98.3531 30.14C95.6531 30.14 94.5731 29.14 94.5731 26.58ZM102.324 30V15.36H105.684V30H102.324ZM115.168 19.76H118.448V30H115.168V28.62C114.588 29.68 113.388 30.28 112.008 30.28C109.388 30.28 107.488 28.06 107.488 24.88C107.488 21.7 109.388 19.48 112.008 19.48C113.388 19.48 114.588 20.08 115.168 21.14V19.76ZM115.208 24.88C115.208 23.42 114.388 22.48 113.048 22.48C111.708 22.48 110.888 23.42 110.888 24.88C110.888 26.34 111.708 27.28 113.048 27.28C114.388 27.28 115.208 26.34 115.208 24.88ZM120.042 28.64L121.482 26.34C122.362 27.04 123.702 27.54 124.882 27.54C125.662 27.54 126.062 27.32 126.062 26.98C126.062 26.64 125.762 26.44 125.102 26.28L123.362 25.86C121.282 25.36 120.422 24.36 120.422 22.92C120.422 20.84 122.122 19.48 124.862 19.48C126.642 19.48 128.302 20.06 129.282 20.96L127.802 23.24C126.742 22.58 125.762 22.24 124.842 22.24C124.122 22.24 123.762 22.46 123.762 22.78C123.762 23.08 124.022 23.24 124.682 23.4L126.422 23.82C128.582 24.36 129.442 25.3 129.442 26.8C129.442 28.96 127.722 30.28 124.842 30.28C122.902 30.28 121.102 29.68 120.042 28.64Z"
				fill="#476885"
			/>
		</svg>
	);

	type InviteProp = {
		phone: string;
		password: string;
	};

	type ModalProp = {
		pin: boolean;
	};

	type stageProp = {
		stage: number;
	};

	const [showModal, setShowModal] = useState<ModalProp>({
		pin: false,
	});

	const [step, setStep] = useState<stageProp>({
		stage: 1,
	});

	const [details, setDetails] = useState<InviteProp>({
		phone: '',
		password: '',
	});

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { loading } = useSelector((state: RootState) => state.auth);

	const [inviteData, setInviteData] = useState<InvitedMemberDetails>({
		id: 0,
		email: '',
		fname: '',
		lname: '',
		clearance: '',
		merchant_email: '',
		identifier: '',
		accepted: 0,
		accepted_at: '',
		expires_at: '',
		created_at: '',
		updated_at: '',
		deleted_at: '',
	});

	function handleFieldChange(e: any) {
		setDetails({
			...details,
			[e.target.name]: e.target.value,
		});
	}

	async function getData(identifier: string | null | undefined) {
		const resp = await dispatch(
			getSupportInviteData({ identifier: identifier })
		);

		if (resp.payload?.status === 'success') {
			setInviteData(resp.payload?.data?.data);
		}
	}

	const params = useParams();

	React.useEffect(() => {
		const identifier = params?.id;
		getData(identifier);
	}, []);

	async function handleSupport() {
		const resp = await dispatch(
			addTeamMember({
				identifier: inviteData.identifier,
				password: details?.password,
			})
		);

		if (resp.payload.status === 'success') {
			navigate('/login');
		}
	}

	return (
		<>
			<AuthThreeLayoutWrap>
				<div className="team-invite-wrap-container">
					<div className="top-wrap">
						<figure className="img-box">{atlasAuthLogo}</figure>
					</div>
					{/* white content card start */}
					<div className="white-content-card">
						<div className="title-box">
							<p className="sub-title">Welcome to Atlas</p>
							<p className="main-title">{inviteData.fname}</p>
						</div>
						{/* role and email box start */}
						<div className="role-email-box-wrap">
							<div className="badge-box role">
								<span>{inviteData.clearance}</span>
							</div>
							<div className="badge-box email">
								<span>{inviteData.email}</span>
							</div>
						</div>
						{/* role and email box end */}
						{/* stage 1 ----------------------- */}
						{step?.stage === 1 && (
							<>
								{/* des box start */}
								<div className="des-box">
									<p className="text">
										You have been added to Atlas as a Support Agent, to verify
										it’s you kindly request an auth code with you mobile Number
									</p>
								</div>
								{/* des box end */}
								{/* input field form styart */}
								<form
									onSubmit={(e) => {
										e.preventDefault();
									}}
									action=""
									autoComplete="off"
									className="form-field-wrap"
								>
									<RavenInputField
										value={details?.phone}
										onChange={handleFieldChange}
										color="deep-green-light"
										type={`phone`}
										label="Mobile Number * "
										name={`phone`}
										placeholder={`E.g 090311412...`}
									/>
								</form>
								{/* input field form end */}
								<form
									action=""
									onSubmit={(e) => {
										e.preventDefault();
										setShowModal((prev) => {
											return { ...prev, pin: true };
										});
									}}
								>
									{' '}
									<RavenInputField
										type={`submit`}
										value={`Continue`}
										color={`deep-green-light`}
										className="btn-submit"
										disabled={!details?.phone}
									/>
								</form>
							</>
						)}
						{/* stage 1 end ------------------- */}
						{/* stage 2 start ----------------------- */}
						{step?.stage === 2 && (
							<>
								{/* des box start */}
								<p style={{ margin: '2rem 0rem 1rem 0rem' }} className="text">
									Put a Password you won’t forget
								</p>
								{/* des box end */}
								{/* input field form styart */}
								<form
									onSubmit={(e) => {
										e.preventDefault();
									}}
									action=""
									autoComplete="off"
									className="form-field-wrap"
								>
									<RavenInputField
										value={details?.password}
										onChange={handleFieldChange}
										color="deep-green-light"
										type={`password`}
										label="New Password * "
										name={`password`}
										placeholder={`Enter Password`}
									/>
								</form>
								{/* input field form end */}
								<form
									action=""
									onSubmit={(e) => {
										e.preventDefault();
										handleSupport();
										// setShowModal((prev) => {
										// 	return { ...prev, pin: true };
										// });
									}}
								>
									{' '}
									<RavenInputField
										type={`submit`}
										value={`Create Account`}
										color={`deep-green-light`}
										className="btn-submit"
										loading={loading}
										disabled={!details?.password}
									/>
								</form>
							</>
						)}
						{/* stage 2 end ----------------------- */}
					</div>
					{/* white content card end */}
				</div>
			</AuthThreeLayoutWrap>

			{/* pin modal start */}
			<ConfirmationPinModal
				setStep={(): any => {
					setStep((prev) => {
						return { ...prev, stage: 2 };
					});
					setShowModal((prev) => {
						return { ...prev, pin: false };
					});
				}}
				visible={showModal?.pin}
				onClose={(): any => {
					setShowModal((prev) => {
						return { ...prev, pin: false };
					});
				}}
			/>
			{/* pin modal end */}
		</>
	);
};

export default TeamInviteIndex;
